import SearchResolver from 'resolvers/RTMResolvers/SearchResolver';

export default (() => {
  let searchResolver;
  let isRegistered = false;

  const search = (params) => searchResolver.search(params);

  const suggest = (params) => searchResolver.suggest(params);

  const triggerIndexing = (params) => searchResolver.triggerIndexing(params);

  const getIndexStatus = (params) => searchResolver.getIndexStatus(params);

  return {
    isRegistered: () => isRegistered,
    register: (connectionProvider) => {
      isRegistered = true;
      searchResolver = new SearchResolver(connectionProvider);
    },
    search,
    suggest,
    triggerIndexing,
    getIndexStatus,
  };
})();
